<script setup>
import { computed, inject } from 'vue';

const I18n = inject('I18n');

const props = defineProps({
  modalidad: { type: Object, required: true },
});

const icono = computed(() => {
  if (props.modalidad.periodicidad.nombre == 'mensual') {
    return 'calendar-alt';
  }
  return 'calendar-day';
});

const tooltip = computed(() => {
  return I18n.t(props.modalidad.periodicidad.nombre)
});
</script>

<template>
  <i
    :class="`fa fa-${icono}`"
    v-tooltip="tooltip"
  >
  </i>
</template>
